import styled from "styled-components"

import {Input as InputBase} from "@irati/ui/src/FormItem"
import ButtonBase from "@irati/ui/src/Button"

export const Input = styled(InputBase)`
  margin-top: 10px;
  > div {
    padding: 0;
  }
`

export const Button = styled(ButtonBase)`
  margin-top: 15px;
  width: 100%;
`
